export default {"src":"/_next/static/media/logo.81229754.svg","height":35,"width":355,"blurWidth":0,"blurHeight":0};